import dispatcher from './store/dispatcher'
import ConfirmationDialog from './confirmation-dialog.container'
import { openConfirmationDialog as openConfirmationDialogAction } from './store/actions'

const openConfirmationDialog = options =>
  dispatcher.dispatch(openConfirmationDialogAction(options))

export { dispatcher, ConfirmationDialog, openConfirmationDialog }
